import request from '@/api/httpRequest2'

// 查询字典数据列表
export function getDictList(dictType) {
  return request({
    url: '/system/dict/data/list',
    method: 'get',
    params: {
      dictType,
      pageNum: 1,
      pageSize: 100
    }
  })
}

// 查询字典数据详细
export function getDictData(dictCode) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'get'
  })
}

// 新增字典数据
export function addDictData(data) {
  return request({
    url: '/system/dict/data',
    method: 'post',
    data: data
  })
}

// 修改字典数据
export function updateDictData(data) {
  return request({
    url: '/system/dict/data',
    method: 'put',
    data: data
  })
}

// 删除字典数据
export function delDictData(dictCode) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'delete'
  })
}

// 导出字典数据
export function exportDictData(query) {
  return request({
    url: '/system/dict/data/export',
    method: 'get',
    params: query
  })
} 